
const state = () => ({
  /**
   * @type Boolean
   */
  tpv: false,

  /**
   * @type Boolean
   */
  event: false,
})

const getters = {
  availableModes (state, getters, rootState, rootGetters) {
    const workingMethods = rootGetters['rummage/integration']?.config?.working_methods
    return Array.isArray(workingMethods) ? workingMethods : null
  },
  showTpvMode (state, getters) {
    return getters.availableModes
      ? getters.availableModes.includes('tpv')
      : true // default value = ON
  },
  showEventMode (state, getters) {
    return getters.availableModes
      ? getters.availableModes.includes('event')
      : false // default value = OFF
  },
}

const mutations = {
  enableTpvMode (state) {
    state.tpv = true
  },
  disableTpvMode (state) {
    state.tpv = false
  },
  setUpEventMode (state) {
    state.event = localStorage.getItem('eventMode') === 'on'
  },
  tearDownEventMode (state) {
    state.event = false
    localStorage.removeItem('eventMode')
  },
  toggleEventMode (state) {
    state.event = ! state.event
    localStorage.setItem('eventMode', state.event ? 'on' : 'off')
  },
}

const actions = {}
  
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
